module.exports = __webpack_public_path__ + "static/media/home-family.6e816043.jpg";